import { render, staticRenderFns } from "./SendOrderTiktok.vue?vue&type=template&id=1e4e620a&scoped=true"
import script from "./SendOrderTiktok.vue?vue&type=script&lang=js"
export * from "./SendOrderTiktok.vue?vue&type=script&lang=js"
import style0 from "./SendOrderTiktok.vue?vue&type=style&index=0&id=1e4e620a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e620a",
  null
  
)

export default component.exports